import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Doubt({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Doubt</title>
      <path
        d="M8.25 10C8.25 10.4142 8.58579 10.75 9 10.75C9.41421 10.75 9.75 10.4142 9.75 10H8.25ZM12 13L12 12.25C11.8011 12.25 11.6103 12.329 11.4697 12.4697C11.329 12.6103 11.25 12.8011 11.25 13H12ZM11.25 14C11.25 14.4142 11.5858 14.75 12 14.75C12.4142 14.75 12.75 14.4142 12.75 14H11.25ZM9.75 10C9.75 9.55499 9.88196 9.11998 10.1292 8.74997L8.88199 7.91661C8.46993 8.5333 8.25 9.25832 8.25 10H9.75ZM10.1292 8.74997C10.3764 8.37996 10.7278 8.09157 11.139 7.92127L10.5649 6.53545C9.87971 6.81928 9.29404 7.29993 8.88199 7.91661L10.1292 8.74997ZM11.139 7.92127C11.5501 7.75098 12.0025 7.70642 12.439 7.79323L12.7316 6.32206C12.0042 6.17736 11.2502 6.25162 10.5649 6.53545L11.139 7.92127ZM12.439 7.79323C12.8754 7.88005 13.2763 8.09434 13.591 8.40901L14.6517 7.34835C14.1272 6.8239 13.459 6.46675 12.7316 6.32206L12.439 7.79323ZM13.591 8.40901C13.9057 8.72368 14.12 9.12459 14.2068 9.56105L15.6779 9.26841C15.5333 8.54098 15.1761 7.8728 14.6517 7.34835L13.591 8.40901ZM14.2068 9.56105C14.2936 9.99751 14.249 10.4499 14.0787 10.861L15.4645 11.4351C15.7484 10.7498 15.8226 9.99584 15.6779 9.26841L14.2068 9.56105ZM14.0787 10.861C13.9084 11.2722 13.62 11.6236 13.25 11.8708L14.0834 13.118C14.7001 12.706 15.1807 12.1203 15.4645 11.4351L14.0787 10.861ZM13.25 11.8708C12.88 12.118 12.445 12.25 12 12.25L12 13.75C12.7417 13.75 13.4667 13.5301 14.0834 13.118L13.25 11.8708ZM11.25 13V14H12.75V13H11.25Z"
        fill={color ?? 'currentColor'}
      />
      <circle cx="12" cy="17" r="1" fill={color ?? 'currentColor'} />
    </svg>
  );
}
